import { render, staticRenderFns } from "./BindsArrowRightIcon.vue?vue&type=template&id=5dc56f43&"
import script from "./BindsArrowRightIcon.vue?vue&type=script&lang=js&"
export * from "./BindsArrowRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports